const privateIpRegex = /(^192\.168\.([0-9]|[0-9][0-9]|[0-2][0-5][0-5])\.([0-9]|[0-9][0-9]|[0-2][0-5][0-5]))|(^172\.([1][6-9]|[2][0-9]|[3][0-1])\.([0-9]|[0-9][0-9]|[0-2][0-5][0-5])\.([0-9]|[0-9][0-9]|[0-2][0-5][0-5]))|(^10\.([0-9]|[0-9][0-9]|[0-2][0-5][0-5])\.([0-9]|[0-9][0-9]|[0-2][0-5][0-5])\.([0-9]|[0-9][0-9]|[0-2][0-5][0-5]))/

const FIREBASE_CONFIG = () => {
  const { host } = window.location

  if (host.includes('localhost') || host.includes('dev') || host.includes('ngrok') || privateIpRegex.test(host)) {
    var dev = {
      apiKey: 'AIzaSyBxGg0n3MKmDnLnN8uTLSAU8EpFWIuNcw8',
      authDomain: 'catalogo-dev.firebaseapp.com',
      databaseURL: 'https://catalogo-dev.firebaseio.com',
      projectId: 'catalogo-dev',
      storageBucket: 'catalogo-dev.appspot.com',
      messagingSenderId: '710289528617',
      appId: '1:710289528617:web:36fbfb4a78d81597f78938',
      measurementId: 'G-11K627ZTVV'
    }
    return dev
  } else {
    var prod = {
      apiKey: 'AIzaSyBQCjmZJc-4n5kxP7mLQtY8KzcF9xtWEZ0',
      authDomain: 'vr-player-example.firebaseapp.com',
      databaseURL: 'https://vr-player-example.firebaseio.com',
      projectId: 'vr-player-example',
      storageBucket: 'vr-player-example.appspot.com',
      messagingSenderId: '998610050257',
      appId: '1:998610050257:web:251fdb03210c774a92b9f0',
      measurementId: 'G-301S87W9VF'
      }
    return prod
  }
}
const AWS_CONFIG = () => {
  const { host } = window.location

  if (host.includes('localhost') || host.includes('dev') || host.includes('ngrok') || privateIpRegex.test(host)) {
    var dev = {
      viewerFrontEndUrl: 'https://dev.viewer.imersys.com/',
      ambiaInstallerUrl: 'ms-appinstaller:?source=https://d2fz58pa8enw5t.cloudfront.net/public/installer/ambia-vr.appinstaller'
    }
    return dev
  } else {
    var prod = {
      viewerFrontEndUrl: 'https://viewer.imersys.com/',
      ambiaInstallerUrl: 'ms-appinstaller:?source=https://d2fz58pa8enw5t.cloudfront.net/public/installer/ambia-vr.appinstaller'
    }
    return prod
  }
}

export default {
  FIREBASE_CONFIG,
  AWS_CONFIG
}
